import { Component, Input } from '@angular/core';
import { Store } from '@ngxs/store';
import { resendActivationEmail } from 'src/app/core/store/user/user.actions';

@Component({
  selector: 'app-link-expired-error',
  templateUrl: './link-expired-error.component.html',
  styleUrls: ['./link-expired-error.component.scss'],
})
export class LinkExpiredErrorComponent {
  @Input() userToken!: string;
  @Input() onBackToSignIn!: () => void;

  isDisabled = false;
  errorMessage = '';
  successMessage = '';

  constructor(private store: Store) {}

  resendEmail() {
    this.isDisabled = true;
    this.errorMessage = '';
    this.successMessage = '';

    this.store.dispatch(new resendActivationEmail(this.userToken)).subscribe({
      next: (res) => {
        this.isDisabled = false;

        this.successMessage = 'Email has been resent. Please check your inbox.';
      },
      error: (err) => {
        this.isDisabled = false;
        this.errorMessage = 'Unable to resend email. Please try again.';
      },
    });
  }
}
